import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | Get Online Crew";
  }, []);

  return (
    <>
      <Navbar />
      <main
        className="bg-goc-light min-h-[60vh] flex items-center"
        data-testid="notfound-page"
      >
        <div className="max-w-2xl mx-auto text-center px-4 py-24">
          <p className="text-sm font-semibold uppercase tracking-widest text-goc-primary">
            404
          </p>
          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight text-goc-text">
            We couldn&apos;t find that page.
          </h1>
          <p className="mt-4 text-goc-muted">
            The link may be broken or the page may have moved. Let&apos;s get you
            back on track.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center rounded-lg bg-goc-primary px-6 py-3 text-sm font-semibold text-white hover:bg-goc-deep transition-colors"
              data-testid="notfound-home-cta"
            >
              Back to home
            </Link>
            <Link
              to="/#lead-form"
              className="inline-flex items-center rounded-lg border border-goc-border bg-white px-6 py-3 text-sm font-semibold text-goc-text hover:border-goc-primary hover:text-goc-primary transition-colors"
              data-testid="notfound-lead-cta"
            >
              Get my website
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
